
import {isEmpty} from "../utils/commons";
import {submitChangePassword} from "../apis/security_apis";

export const CHANGE_PASSWORD_ON_CHANGE = "changePasswordOnChange";
export const CHANGE_PASSWORD_ON_VALIDATE = "changePasswordOnValidate";
const CHANGE_PASSWORD_SUBMITTING = "changePasswordSubmitting";
const CHANGE_PASSWORD_SUBMITTED = "changePasswordSubmitted";
const CHANGE_PASSWORD_RESET_FIELDS = "changePasswordResetFields";

const initLoginErrors = () => ({
    newPassword: "",
    confirmNewPassword: "",
})

const initState = () => ({
        newPassword: "",
        confirmNewPassword: "",
        base64Email: "",
        error: "",
        info: "",
        submitting: false,
        fieldErrors: initLoginErrors(),
})

const state = initState();

const mutations = {
    [CHANGE_PASSWORD_ON_CHANGE] (state, payload) {
        Object.assign(state, {[payload.name]:payload.value});
    },
    [CHANGE_PASSWORD_ON_VALIDATE] (state, payload) {
        Object.assign(state, {fieldErrors: {...payload}});
    },
    [CHANGE_PASSWORD_SUBMITTING] (state) {
        Object.assign(state, {submitting: true, error: "", info: ""});
    },
    [CHANGE_PASSWORD_SUBMITTED] (state, payload) {
        Object.assign(state, {submitting: false, error: payload.error, info: payload.info});
    },
    [CHANGE_PASSWORD_RESET_FIELDS] (state) {
        Object.assign(state, initState());
    }
}

const actions = {
    [CHANGE_PASSWORD_ON_CHANGE] ({commit}, payload) {
        commit(CHANGE_PASSWORD_ON_CHANGE, payload)
    },
    [CHANGE_PASSWORD_ON_VALIDATE] ({commit, state}) {
        let errors = {};
        ["newPassword", "confirmNewPassword"].forEach( key => {

            if(isEmpty(state[key])) {
                errors[key] = "This field is required";
            }

        });

        if(state["newPassword"] !== state["confirmNewPassword"]) {
            errors["confirmNewPassword"] = "This should be the same as entered password."
        }

        commit(CHANGE_PASSWORD_ON_VALIDATE, errors);
        if(Object.keys(errors).length > 0) {
            commit(CHANGE_PASSWORD_ON_CHANGE, {name: "error", value: "Some fields invalid"});
        }else {
            commit(CHANGE_PASSWORD_ON_CHANGE, {name: "error", value: ""});
        }
    },
    changePassword ({commit, state}) {

        commit(CHANGE_PASSWORD_SUBMITTING);
        submitChangePassword({newPassword: state.newPassword, base64resetId: state.base64Email})
            .then((results) => {
                    const info = !results.error?"Password changed successfully.": "";
                    commit(CHANGE_PASSWORD_SUBMITTED, {info,  error: results.error});
                },
                (results) => {
                    let error = !results.error? "Failed submitting change password.": results.error;
                    commit(CHANGE_PASSWORD_SUBMITTED, {info: "", "error": error});
                })


    },
    [CHANGE_PASSWORD_RESET_FIELDS] ({commit}) {
        commit(CHANGE_PASSWORD_RESET_FIELDS);
    }
}


export default {
    state,
    mutations,
    actions
}
